import { cn } from '@/lib/utils'

import { Skeleton, useProductSliderVariants } from '../../../Theme'
import { CompactProductCardSkeleton } from '../../../UiBlocks'
import { SKELETON_COUNTS } from '../../constants'

import type { ProductSliderSkeletonProps } from '../../types'

export function ProductSliderSkeleton({ className, count = SKELETON_COUNTS.productSlider }: ProductSliderSkeletonProps) {
  const {
    productSliderSectionVariants,
    productSliderWrapperVariants,
    productSliderSkeletonGridVariants,
  } = useProductSliderVariants()

  return (
    <section
      className={cn(productSliderSectionVariants(), className)}
      aria-busy="true"
      aria-label="Loading products"
    >
      <Skeleton className="h-10 w-48 mx-auto mb-8" aria-hidden="true" />

      <div className={productSliderWrapperVariants()}>
        <div className={productSliderSkeletonGridVariants()}>
          {Array.from({ length: count }, (_, i) => (
            <CompactProductCardSkeleton key={i} />
          ))}
        </div>
      </div>
    </section>
  )
}
